import React from 'react'

import { t } from 'i18next'

import { downloadImage } from '@/utils/imageUtils'

import { ListWithIcons, TListWithIconsProps } from '@/components/listWithIcons'
import { TPolicyLinkBlock } from '@/components/policyLinkBlock/types'
import { getPolicy } from '@/components/policyLinkBlock/utils'
import checked from '@/shared/images/checked.png'

const checkedImg = downloadImage(checked)

const defaultPolicyTemplate: TPolicyLinkBlock = {
  text: 'By purchasing, you agree to {tos} and {privacyPolicy}, {refundPolicy}.',
  tos: 'T&Cs',
  privacyPolicy: 'Privacy Policy',
  refundPolicy: 'Refund Policy',
}

export const MoneyBackInformation = () => {
  const policyText = getPolicy({
    translationKey: 'selectPlanScreen.purchasePolicy',
    defaultPolicyTemplate: defaultPolicyTemplate,
  })

  const props: TListWithIconsProps = {
    className: 'money-back-information',
    mainTitle: t('selectPlanScreen.moneyBackInformation.title') || 'Money-back information',
    items: [
      {
        id: 1,
        iconNode: <img src={checkedImg.src} alt="checked" />,
        title: policyText,
      },
    ],
  }

  return (
    <div className="money-back-information" key="money-back-information">
      <ListWithIcons {...props} />
    </div>
  )
}
